import { IonCol, IonGrid, IonRow, IonText } from '@ionic/react';
import { cloudOutline, swapHorizontalOutline } from 'ionicons/icons';
import { useTranslation } from 'react-i18next';
import { IntercomArticle } from '../../config/intercom';
import { AppModeOption } from '../../pages/app/app-mode-selection.page';
import { IntercomHelp } from '../help/intercom-help';

interface MachineConnectionTypeSelectionProps {
  onCloudClick: () => void;
  onDirectConnectClick: () => void;
}

const MachineConnectionTypeSelection = (
  props: MachineConnectionTypeSelectionProps
) => {
  const { onCloudClick, onDirectConnectClick } = props;

  const { i18n } = useTranslation();

  return (
    <IonGrid className="ion-no-padding">
      <IonRow>
        <IonCol>
          <AppModeOption
            title={i18n.t('common:app_mode_cloud_title')}
            icon={cloudOutline}
            onClick={onCloudClick}
          >
            {i18n.t('common:cloud_connect_register_explanation')}
          </AppModeOption>
          <AppModeOption
            title={i18n.t('common:app_mode_direct_title')}
            icon={swapHorizontalOutline}
            onClick={onDirectConnectClick}
          >
            {i18n.t('common:direct_connect_register_explanation')}
          </AppModeOption>
        </IonCol>
      </IonRow>
      <IonRow>
        <div className="full-height-width content-center">
          <IonText className="ion-padding ion-text-center" color="medium">
            <IntercomHelp
              articleId={IntercomArticle.DIRECT_CONNECT_OVERVIEW}
              description={i18n.t('common:direct_connect_learn_more')}
            />
          </IonText>
        </div>
      </IonRow>
    </IonGrid>
  );
};

export { MachineConnectionTypeSelection };
